import Work1 from "../../assets/gym back.jpg";
import Work2 from "../../assets/hungry panda.jpg";
import Work3 from "../../assets/Sales Dashboard.png";
import Work4 from "../../assets/Placement.png";
import Work5 from "../../assets/chat app.png";


const Menu = [
    {
      id: 1,
      image: Work1,
      title: "Youth Gym - React FrontEnd WebApp",
      category: "Web Designing",
    },
    {
      id: 2,
      image: Work2,
      title: "Hungry Panda - Responsive WebApp",
      category: "Web Designing",
    },
    {
      id: 3,
      image: Work3,
      title: "Sales Dashboard - Power BI",
      category: "Data Analytics",
    },
    ,
    {
      id: 4,
      image: Work4,
      title: "Placements Dashboard - Power BI",
      category: "Data Analytics",
    },
    {
      id: 5,
      image: Work5,
      title: "Chat Application Y-Chat",
      category: "Web Designing",
    }
  ];
  
export default Menu
